var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('header',{staticClass:"app__header"},[_c('AppTopNavbar')],1),_c('main',{staticClass:"app__content"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }